import { Alert, Badge } from '../../../shared/styles/components/feedback.styles';
import { DetailLabel, DetailRow, DetailValue, MappingBody, MappingHeader, MappingType } from './MaterialGradeModal.styles';

import { Card } from '../../../shared/styles/components/primitives.styles';
import { PiaMaterialMappingResponse } from '../types/material-mapping.api';
import React from 'react';
import SSRIcon from '@ingka/ssr-icon';
import { pluralize } from '../../../shared/utils/formatters.utils';
import { tokens } from '../../../shared/styles/core/tokens';
import warningEmpathizedTriangleIcon from '@ingka/ssr-icon/paths/warning-triangle-colour';

interface MappingResultCardProps {
    mapping: PiaMaterialMappingResponse;
    newGradeId: string;
    currentGradeId?: string;
    affectedCount: number | null;
    excludedCount: number;
    isHighImpact: boolean;
}

export const MappingResultCard: React.FC<MappingResultCardProps> = ({
    mapping,
    newGradeId,
    currentGradeId,
    affectedCount,
    excludedCount,
    isHighImpact
}) => {
    const isMapped = currentGradeId && currentGradeId !== '0';
    const hasMappingRule = mapping.materialGradeId && mapping.materialGradeId !== 0;

    return (
        <Card style={{ marginBottom: tokens.space.md, overflow: 'hidden', padding: 0 }}>
            <MappingHeader>
                <MappingType>Selected Scope</MappingType>
                <Badge variant={isMapped ? 'success' : 'warning'}>
                    {isMapped ? `Current ID: ${currentGradeId}` : 'No Current ID'}
                </Badge>
            </MappingHeader>
            <MappingBody>
                <DetailRow>
                    <DetailLabel>Family:</DetailLabel>
                    <DetailValue>{mapping.familyName || 'All families'}</DetailValue>
                </DetailRow>
                <DetailRow>
                    <DetailLabel>Material Part:</DetailLabel>
                    <DetailValue>{mapping.materialPart || 'All parts'}</DetailValue>
                </DetailRow>
                <DetailRow>
                    <DetailLabel>Change to Grade ID:</DetailLabel>
                    <DetailValue>{newGradeId}</DetailValue>
                </DetailRow>
                {affectedCount !== null && (
                    <DetailRow $highlight={isHighImpact}>
                        <DetailLabel $highlight={isHighImpact}>Will affect:</DetailLabel>
                        <DetailValue $highlight={isHighImpact}>
                            {pluralize(affectedCount)}
                            {isHighImpact && (
                                <>
                                    {' '}
                                    <SSRIcon paths={warningEmpathizedTriangleIcon} />
                                </>
                            )}
                        </DetailValue>
                    </DetailRow>
                )}
                {excludedCount > 0 && (
                    <DetailRow>
                        <DetailLabel>Excluded:</DetailLabel>
                        <DetailValue>{pluralize(excludedCount)}</DetailValue>
                    </DetailRow>
                )}
            </MappingBody>

            {!hasMappingRule && (
                <Alert variant="info" style={{ margin: tokens.space.md, marginTop: 0 }}>
                    <span>
                        <strong>Creating New Mapping Rule:</strong> This scope currently has no PIA mapping rule.
                        Your change will create a new mapping rule for <strong>{mapping.familyName || 'all families'}</strong> with <strong>{mapping.materialPart || 'all parts'}</strong>.
                    </span>
                </Alert>
            )}
        </Card>
    );
};